import { GetterTree } from 'vuex'
import PaymentState, { IPayment } from './states'
import { State } from '@/store/store'

const getters: GetterTree<PaymentState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  paymentLists: (state) => {
    return state.list.result
    const data = state.list.result
    const result: Array<{
      text?: string,
      value?: string,
      payment?: IPayment,
    }> = []
    data.forEach((each) => {
      result.push({
        text: each.name,
        value: each._id,
        payment: each,
      })
    })
    return result
  },
  itemLists: (state) => {
    return state.list.result
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
}

export default getters
